var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34401 8.98367C1.38759 11.0273 1.40938 12.0492 2.16347 12.8061C2.91755 13.5631 3.96705 13.5895 6.06605 13.6422C7.3597 13.6747 8.64063 13.6747 9.9343 13.6422C12.0333 13.5895 13.0828 13.5631 13.8368 12.8061C14.591 12.0492 14.6128 11.0273 14.6563 8.98367C14.6704 8.32654 14.6704 7.67327 14.6563 7.01621C14.6128 4.97249 14.591 3.95065 13.8368 3.19369C13.0828 2.43674 12.0333 2.41037 9.9343 2.35763C8.64063 2.32513 7.3597 2.32513 6.06605 2.35763C3.96705 2.41036 2.91755 2.43673 2.16347 3.19369C1.40938 3.95064 1.38759 4.97249 1.34401 7.01614C1.32999 7.67327 1.32999 8.32654 1.34401 8.98367Z",
    fill: "#842234",
    stroke: "#842234",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 5.66663L6.62785 6.82623C7.7713 7.50229 8.22837 7.50229 9.37184 6.82623L11.3332 5.66663",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b93a5675f8d0008d4ae41585e10e323f.svg";
export { ForwardRef as ReactComponent };